'use strict';

import Moment from 'moment';

const LAST_BATCH_DATE_TIME_FORMAT = 'MM/DD/YYYY , h:mmA';

class StatusIndicatorController {
  constructor(statusIndicatorService, $rootScope) {
    this.$rootScope = $rootScope;
    this.batchStatus = '';
    this.statusIndicatorService = statusIndicatorService;
    this.statusIndicatorService.retrieveStatus();
    this.statusIndicatorService.pollForStatus();
    this.listenForBatchStatusRetrieved();
  }

  setBatchStatus(){
    this.batchStatus = this.statusIndicatorService.batchStatus;
  }

  setBatchTime(batch) {
    if (this.batchHasFinished()) {
      this.setLastBatchDateTime(batch);
    }
  }

  listenForBatchStatusRetrieved() {
    const batchStatusRetrieved = this.statusIndicatorService.getBatchStatusEventName();
    this.$rootScope.$on(batchStatusRetrieved, this.setBatchInfo.bind(this));
  }

  setBatchInfo(event, batch) {
    this.setBatchStatus();
    this.setBatchTime(batch);
  }

  batchHasFinished() {
    return this.statusIndicatorService.batchHasFinished();
  }

  isInProcess() {
    return this.statusIndicatorService.isInProcess();
  }

  setLastBatchDateTime(batch) {
    this.lastBatchDateTime = new Moment(batch.updatedAt).format(LAST_BATCH_DATE_TIME_FORMAT);
  }
}

StatusIndicatorController.$inject = ['statusIndicatorService', '$rootScope'];

export default StatusIndicatorController;



// WEBPACK FOOTER //
// ./app/components/statusIndicator/statusIndicator.controller.js